import { Datagrid, DateField, Filter, FunctionField, ListProps, SelectInput, TextField } from 'react-admin';
import { CustomList, StatusField } from '../../components';
import { statusChoices } from '.';

const CustomFilter = props => {
	return(
		<Filter {...props}>
			<SelectInput
				choices={statusChoices}
				source="status"
    	/>
		</Filter>
	)
} ;

export default function VisitSchedulesList(props: ListProps) {
  return (
    <CustomList 
      {...props} 
      sort={{ field: 'createdAt', order: 'DESC' }}
      filters={<CustomFilter />}
    >
      <Datagrid rowClick="edit">
        
        <DateField 
          locales="pt-BR" 
          options={{ timeZone: 'UTC' }} 
          label="Enviado em" 
          source="createdAt" 
        />
        <TextField label="Nome" source="name" />
        <TextField label="Telefone" source="phone" />
        <TextField label="Nº pessoas" source="countParticipants" />
        <StatusField label="Status" />
      </Datagrid>
    </CustomList>
  );
}
